import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { show_alerta } from '../../funciones.js';
import CONFIG from '../../config.js';

const URL_HORARIOS = `${CONFIG.API_URL}/operaHorarios.php`;

function Horarios({configuracion, acceder, rol}) {
  const [horarios, setHorarios] = useState([]);
  const [espacios, setEspacios] = useState([]);
  const [cursos, setCursos] = useState([]);
  const [cursoSeleccionado, setCursoSeleccionado] = useState('-');
  const navigate = useNavigate();
  const cicloActual = new Date().getFullYear();
  const [formData, setFormData] = useState({
    id: null,
    id_espacio: "",
    curso_grupo: "-",
    hora_desde: '08:00:00',
    hora_hasta: '13:00:00',
    dia_semana: "",
    contraturno: 0,
  });

  // Cargar horarios y espacios
  useEffect(() => {
    if(acceder){
        if(rol===null){
            navigate("/");
        }
        obtenerHorarios(cursoSeleccionado);
    }else{
        localStorage.clear();
        navigate('/');
    }
  }, [cursoSeleccionado, acceder, rol]);

  useEffect(() => {
    obtenerHorarios(formData.curso_grupo);
  }, [formData]);

  const obtenerHorarios = async (GrupoCurso) => {
    console.log('predata: ',cursoSeleccionado);
    console.log(`?curso_grupo=${cursoSeleccionado}&ciclo=${cicloActual}`);
    const res = await axios.get(`${URL_HORARIOS}?curso_grupo=${GrupoCurso}&ciclo=${cicloActual}`);
    console.log(res.data);
    if(!res.data.error) {
        setHorarios(res.data.horarios);
        setEspacios(res.data.espacios);
        setCursos(res.data.cursos);
    }else{
        setHorarios([]);
        setEspacios([]);
        setCursos([]);
        alert("Error al cargar los horarios:", res.data.error);}
    };

  // Abrir modal para nuevo/editar
  const openModal = (horario = null) => {
    if (horario) {
      setFormData(horario);
    } else {
      setFormData({
        id: null,
        id_espacio: "",
        curso_grupo: "-",
        hora_desde: '08:00:00',
        hora_hasta: '13:00:00',
        dia_semana: "",
        contraturno: 0,
      });
    }
    //setIsOpen(true);
  };

  // Guardar datos
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.id) {
        const  resU = await axios.put(`${URL_HORARIOS}?accion=update`, formData);
        console.log(resU.data);
        if(resU.data.success){
          show_alerta('Horario guardado correctamente', 'success');  
          obtenerHorarios(cursoSeleccionado);
        }else{
          show_alerta("Error al guardar el horario:", resU.data.error, 'error');  
        }
    } else {
        const  res = await axios.post(URL_HORARIOS, formData);
        console.log(res.data);
        if(res.data.success){
          show_alerta('Horario guardado correctamente', 'success');  
          obtenerHorarios(cursoSeleccionado);
        }else{
          show_alerta("Error al guardar el horario:", res.data.error, 'error');  
        }
    }  
  };

  return (
    <div className="container-principal">
      <h3 className="mb-4">Horarios</h3>
      <button type="button" 
      className="btn btn-sm btn-success my-1" 
      data-bs-toggle="modal" 
      data-bs-target="#exampleModal"
      onClick={() => openModal(null)}
      >
        ➕ Nuevo Horario
      </button>
      <div>
        <div className="input-group mb-3">
          <label className="input-group-text" htmlFor="inputGroupSelect01">
            <i className="fa-solid fa-magnifying-glass me-1"></i>
            Selecionar curso
          </label>
          <select
            id="inputGroupSelect01"
            className="form-select"
            value={cursoSeleccionado}
            onChange={(e) => setCursoSeleccionado(e.target.value)}
            required
          >
            <option value="0">Seleccionar curso</option>
            {cursos.map((c, index) => (
                <option key={index} value={`${c.orden}-${c.seccion}`}>
                  {c.orden}-{c.seccion} ({c.denominacion}) 
                </option>
            ))}
          </select>
        </div>
      </div>
      <table className="table table-sm" style={{backgroundColor:'#000'}}>
        <thead  >
          <tr >
            <th className="border px-2 py-1">Día</th>
            <th className="border px-2 py-1">Espacio</th>
            <th className="border px-2 py-1">Desde</th>
            <th className="border px-2 py-1">Hasta</th>
            <th className="border px-2 py-1">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {horarios.map((h, index) => (
            <tr key={index} className={`${h.contraturno==='Si'?'bg-primary':'bg-success'}`}>
              <td className="border px-2 py-1">{h.dia_semana}</td>
              <td className="border px-2 py-1">{h.nombre_espacio}</td>
              <td className="border px-2 py-1">{h.hora_desde}</td>
              <td className="border px-2 py-1">{h.hora_hasta}</td>
              <td className="border px-2 py-1">
                <button
                  className="btn btn-sm btn-warning"
                  data-bs-toggle="modal" 
                  data-bs-target="#exampleModal"
                  onClick={() => openModal(h)}
                >
                  ✏️ Editar
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

    {/* Modal */}
    <div className="modal fade" id="exampleModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
            <div className="modal-content">
            <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                    {formData.id ? "Editar Horario" : "Nuevo Horario"}
                </h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <form onSubmit={handleSubmit}>
                <div className="my-2">    
                {/* Selector de curso*/}
                    <select
                        className="form-select mb-1"
                        value={formData.curso_grupo}
                        onChange={(e) => setFormData({ ...formData, curso_grupo: e.target.value })}
                        required
                    >
                        <option value="">Seleccionar curso</option>
                        {cursos.map((c, index) => (
                        <option key={index} value={`${c.orden}-${c.seccion}`}>
                            {c.orden}-{c.seccion} ({c.denominacion})
                        </option>
                        ))}
                    </select>
                </div>
                {/*Dia y turno*/}
                <div>
                    <select 
                        className="form-select mb-1"
                        value={formData.dia_semana}
                        onChange={(e) => setFormData({ ...formData, dia_semana: e.target.value })}
                        required
                    >
                        <option value="">Seleccionar Dia de la Semana</option>
                        
                        <option value='lunes'>Lunes</option>
                        <option value='martes'>Martes</option>
                        <option value='miércoles'>Miércoles</option>
                        <option value='jueves'>Jueves</option>
                        <option value='viernes'>Viernes</option>
                    </select>

                    <label className="flex items-center gap-2">
                        <input
                        type="checkbox"
                        checked={formData.contraturno === 1}
                        onChange={(e) =>
                            setFormData({ ...formData, contraturno: e.target.checked ? 1 : 0 })
                        }
                        />
                        Contraturno
                    </label>
                </div>
                <div>                    
                  {/* Selector de materia*/}
                    <select
                        className="form-select mb-1"
                        value={formData.id_espacio}
                        onChange={(e) => setFormData({ ...formData, id_espacio: e.target.value })}
                        required
                    >
                        <option value="">Seleccionar Espacio</option>
                        {espacios.map((esp, index) => (
                        <option key={index} value={esp.id}>
                            {esp.nombre_espacio}
                        </option>
                        ))}
                    </select>
                </div>
                {/*Horario*/}
                <div className="my-1">
                    <label>Hora desde</label>
                    <input
                        type="time"
                        className="w-full border px-2 py-1"
                        value={formData.hora_desde}
                        onChange={(e) => setFormData({ ...formData, hora_desde: e.target.value })}
                        required
                    />
                    <span className="mx-2">|</span>
                    <label>Hora hasta</label>
                    <input
                        type="time"
                        className="w-full border px-2 py-1"
                        value={formData.hora_hasta}
                        onChange={(e) => setFormData({ ...formData, hora_hasta: e.target.value })}
                        required
                    />
                </div>
                
                
                <div className="mt-3">
                        <button
                        type="button"
                        className="btn btn-sm btn-secondary me-1"
                        data-bs-dismiss="modal"
                        >
                        Cancelar
                        </button>
                        <button
                        type="submit"
                        className="btn btn-sm btn-primary  me-1"
                        data-bs-dismiss="modal"
                        >
                        Guardar
                        </button>
                </div>
                </form>
            </div>
            </div>
        </div>
    </div>


    </div>
  );
}

export default Horarios;